<template>
  <div>
    <fullscreen :fullscreen.sync="fullscreen" ref="fullscreen" v-if="fullscreen">
      <div class="ts-w-full ts-bg-white ts-p-8 ts-h-full">
        <div class="ts-flex ts-justify-between">
          <div class="ts-text-center ts-w-48">
            <img src="@/assets/logo.png" alt class="ts-w-32 ts-ml-5" />
            <h1
              class="ts-font-heading-font ts-text-3xl ts-tracking-widest ts-uppercase ts-mt-2"
            >{{ company.company_name_en }}</h1>
          </div>
          <div class="ts-border-b-2 ts-border-pink-600 ts-flex ts-items-end">
            <h2
              class="ts-uppercase ts-text-heading-color ts-font-heading-font ts-text-2xl ts-font-bold"
            >{{ $t('gameBetting.betting') }}</h2>
          </div>
          <div class="ts-text-right ts-relative">
            <div class="ts-flex ts-space-x-2">
              <div>
                <p
                  class="ts-font-heading-font ts-text-para-color ts-font-semibold ts-text-base ts-mb-0"
                >{{ currentUserLogin.user.name }}</p>
                <p
                  class="ts-font-heading-font ts-text-para-color ts-font-semibold ts-text-base ts-mb-0"
                >{{ balance }}</p>
              </div>
              <i class="fa fa-user fa-2x ts-fill-current ts-text-blue-700 ts-ml-2"></i>
            </div>
            <span class="ts-absolute ts-top-0 ts-right-0 ts--mt-3">
              <small class="ts-font-heading-font ts-mr-8 ts-text-red-600 ts-font-semibold">
                {{
                currentUserLogin.user_type == 2 ? 'Supper Dealer' :
                ( currentUserLogin.user_type ==3 ? 'Dealer' : 'Office Staff')
                }}
              </small>
            </span>
          </div>
          <div
            v-if="message"
            class="ts-absolute ts-right-0 ts-top-0 ts-py-2 ts-px-3 ts-z-30 ts-w-1/6 ts-rounded-md ts-mt-2 ts-mr-2 ts-transition ts-duration-500 ts-font-semibold ts-shadow-md"
            :class="
              type_message == 'success' ? ' ts-bg-green-500' : 'ts-bg-red-500'
            "
          >
            <span class="ts-capitalize ts-font-robot ts-text-white">
              {{
              message
              }}
            </span>
          </div>
        </div>
        <div class="ts-mt-16 ts-space-y-8 xl:ts-flex xl:ts-space-x-8 xl:ts-space-y-0 ts-mx-auto">
          <div class="ts-border ts-p-5 ts-rounded-lg xl:ts-w-1/4 ts-relative" style="height:60vh">
            <span
              class="ts-font-heading-font ts-text-base ts-font-semibold ts-absolute ts-top-0 ts--mt-6 ts-bg-pink-600 ts-text-white ts-px-4 ts-py-2 ts-rounded-tl-full ts-rounded-br-full"
            >{{ $t('gameBetting.gameAvailable') }}</span>
            <GameTypeNew v-model="model" @game="gameSelect" class="ts-mt-3" />
          </div>
          <div class="ts-border ts-p-5 ts-rounded-lg xl:ts-w-1/2 ts-relative">
            <span
              class="ts-font-heading-font ts-text-base ts-font-semibold ts-absolute ts-top-0 ts--mt-6 ts-bg-pink-600 ts-text-white ts-px-4 ts-py-2 ts-rounded-tl-full ts-rounded-br-full"
            >{{ $t('gameBetting.pickYourNumber') }}</span>
            <PickupNumberNew
              v-if="model.game_set_id"
              v-model="model"
              :gameSet="game_set"
              class="ts-mt-6"
              ref="picknumber"
            />
            <h2
              v-if="!model.game_set_id"
              class="ts-text-2xl ts-uppercase ts-mx-auto ts-text-gray-500 ts-mt-1/4"
              style="width:fit-content"
            >{{ $t('gameBetting.pleaseSelectDrawToBet') }}</h2>
          </div>
          <div class="ts-border ts-p-5 ts-rounded-lg xl:ts-w-1/4 ts-relative">
            <span
              class="ts-font-heading-font ts-text-base ts-font-semibold ts-absolute ts-top-0 ts--mt-6 ts-bg-pink-600 ts-text-white ts-px-4 ts-py-2 ts-rounded-tl-full ts-rounded-br-full"
            >{{ $t('gameBetting.myCart') }} | {{ countCart }}</span>
            <cart-list :list="cart" @deleteGame="deleteItemCart" />
            <div class="ts-flex ts-justify-between ts-items-center">
              <ts-button
                v-if="countCart > 0"
                color="primary"
                :waiting="waiting"
                @click.prevent="onSave"
              >{{ $t('submit') }}</ts-button>
               <h3
                class="ts-font-heading-font ts-text-lg"
              >{{ $t('gameBetting.total') + ' : ' + totalAmount.toLocaleString() }}</h3>
            </div>
          </div>
        </div>
      </div>
    </fullscreen>
  </div>
</template>

<script>
import fullscreen from 'vue-fullscreen'
import Vue from 'vue'
import { mapActions } from 'vuex'
Vue.use(fullscreen)
import moment from 'moment'
import GameType from './components/game-type'
import GameTypeNew from './components/game-type-new.vue'
import PickupNumber from './components/pickup-number'
import PickupNumberNew from './components/pick-number-new'
import CartList from './components/cart-list'
import { Errors } from 'form-backend-validation'

export default {
  name: 'gameBettings',
  components: {
    GameType,
    GameTypeNew,
    PickupNumber,
    PickupNumberNew,
    CartList
  },
  data() {
    return {
      current_date: moment().format('DD-MM-YYYY'),
      loading: false,
      fullscreen: false,
      waiting: false,
      add_cart: false,
      rebuild: false,
      type_message: null,
      message: null,
      balance: 0,
      errors: new Errors(),
      company: [],
      game_set: {},
      model: {
        game_set_id: null,
        game_type_id: null,
        total_betting_amount: 0,
        betting_detail: [],
        picked_number: []
      },
      cart: {
        game_set_id: null,
        game_type_id: null,
        bets: []
      }
    }
  },
  created() {
    this.fullscreen = true
    this.$nextTick(() => {
      this.$refs['fullscreen'].toggle([true])
    })
    this.fetCompany()
    this.balance = this.$store.state.authUser.user.dealer.main_balance
  },
  computed: {
    currentUserLogin() {
      return this.$store.state.authUser
    },
    countCart() {
      return this.cart.bets.length
    },
    totalAmount() {
      return _.sumBy(this.cart.bets, function(o) {
        return o.total_betting_amount
      })
    }
  },
  methods: {
    ...mapActions('game/gameBetting', [
      'getCompany',
      'getGameSet',
      'store',
      'validate'
    ]),
    fetCompany() {
      this.loading = true
      this.getCompany()
        .then(response => {
          this.company = Object.assign({}, ...response.data)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    gameSelect(value) {
      this.game_set = value
      ;(this.cart.game_set_id = null),
        (this.cart.game_type_id = null),
        (this.cart.bets = [])
        this.$nextTick(() => {
          let f = this.$refs['picknumber']
          f.createChannelList()
        })
    },
    // onValidate() {
    //   this.errors = new Errors()
    //   this.add_cart = true
    //   this.validate(this.model)
    //     .then(response => {
    //       let { game_set_id, game_type_id, ...data } = this.model
    //       this.cart.bets.push(_.cloneDeep(data))
    //       this.rebuild = true
    //       this.clearInput()
    //     })
    //     .catch(error => {
    //       this.$toasted.error(error.message)
    //       this.type_message = 'error'
    //       this.message = error.message
    //       this.removeToasted()
    //       // this.errors = new Errors(error.errors)
    //     })
    //     .finally(() => {
    //       this.add_cart = false
    //     })
    // },
    deleteItemCart(index) {
      this.cart.bets.splice(index, 1)
    },
    async onSave() {
      this.waiting = true
      this.store(this.cart)
        .then(response => {
          this.type_message = 'success'
          this.message = response.message
          this.removeToasted()
          this.balance = response.main_balance
          this.clearInput()
          this.cart.bets = []
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.type_message = 'error'
          this.message = error.message
          this.removeToasted()
        })
        .finally(() => {
          this.waiting = false
        })
    },
    removeToasted() {
      setTimeout(() => (this.message = ''), 3000)
    },
    clearInput() {
      this.errors = new Errors()
      this.model.picked_number.forEach(el => {
        el.value = ''
      })
    }
  },
  watch: {
    fullscreen: function(value) {
      if (value == false) {
        this.$router.push({ name: 'game-betting' })
      }
    },
    'model.betting_detail': {
      handler(value) {
        this.model.total_betting_amount = _.sumBy(value, function(o) {
          return o.betting_amount * o.multiplier
        })
      },
      deep: true
    }
  }
}
</script>
